<template>
  <div data-v-d5c8035c="" data-v-2ac6a5fc="" class="container promotion">
    <van-sticky :offset-top="50">
      <div class="tab-div" style="background-color: #141414">
        <div class="tab-box">
          <div @click="changeIndex(index)" :class="'tab-item ' + (index == selectIndex ? 'tab-item-select' : '')" v-for="(item, index) in tabs" :key="index">{{ item }}</div>
        </div>
      </div>
    </van-sticky>
    <div v-if="selectIndex == 0" data-v-d5c8035c="" class="list">
      <van-sticky :offset-top="88">
        <van-tabs v-model="active" color="#cca352" title-active-color="#cca352" title-inactive-color="#6a6a73" background="#141414" style="margin-bottom: 10px">
          <van-tab v-for="(item, index) in activitytypelist" :key="index" :title="item.name" :name="item.id"></van-tab>
        </van-tabs>
      </van-sticky>
      <div v-if="active == -1">
        <div data-v-d5c8035c="" v-for="(item, index) in activitylistList" :key="index" @click="$parent.goNav(`/activeInfo?id=${item.id}`)">
          <div data-v-d5c8035c="" class="promo">
            <a data-v-d5c8035c="" href="javascript:void (0);" class="item.link">
              <div data-v-d5c8035c="" class="promo-img">
                <img data-v-d5c8035c="" class="img-responsive" :src="item.banner" lazy="loaded" />
                <div data-v-d5c8035c="" class="promo-label">{{ item.type_name }}</div>
              </div>
              <div data-v-d5c8035c="" class="info">
                <div data-v-d5c8035c="" class="title">
                  <h3 data-v-d5c8035c="">{{ item.title }}</h3>
                </div>
                <p data-v-d5c8035c=""></p>
                <span data-v-d5c8035c="" class="date" style="display: none;">{{ item.created_at }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div v-else>
        <div data-v-d5c8035c="" v-for="(item, index) in activitylistList.filter(e => e.type == active)" :key="index" @click="$parent.goNav(`/activeInfo?id=${item.id}`)">
          <div data-v-d5c8035c="" class="promo">
            <a data-v-d5c8035c="" href="javascript:void (0);" class="item.link">
              <div data-v-d5c8035c="" class="promo-img">
                <img data-v-d5c8035c="" class="img-responsive" :src="item.banner" lazy="loaded" />
                <div data-v-d5c8035c="" class="promo-label">{{ item.type_name }}</div>
              </div>
              <div data-v-d5c8035c="" class="info">
                <div data-v-d5c8035c="" class="title">
                  <h3 data-v-d5c8035c="">{{ item.title }}</h3>
                </div>
                <p data-v-d5c8035c=""></p>
                <span data-v-d5c8035c="" class="date" style="display: none;">{{ item.created_at }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div data-v-d5c8035c="" class="list" v-if="selectIndex == 1">
      <van-sticky :offset-top="88">
        <van-tabs @change="selectTask" v-model="active1" color="#cca352" title-active-color="#cca352" title-inactive-color="#6a6a73" background="#141414" style="margin-bottom: 10px">
          <van-tab v-for="(item, index) in activitytypelist1" :key="index" :title="item.name" :name="item.id"></van-tab>
        </van-tabs>
      </van-sticky>
      <div style="width: 100%; height: 160px; margin-top: 10px">
        <van-row style="color: #c2bbc6">
          <van-col :span="12">
            今日充值 <span style="color: #cca352">{{ usrdata.sum }}</span>
          </van-col>
          <van-col :span="12" style="text-align: right">
            今日有效投注 <span style="color: #cca352">{{ usrdata.bet }}</span>
          </van-col>
          <van-col :span="24">
            <div style="height: 80px; position: relative; margin-top: 20px">
              <div style="border-top: 1px solid #c2bbc6; z-index: 1; position: absolute; z-index: 1; width: 98%; left: 0; top: 20px" />
              <div style="display: flex; justify-content: flex-end">
                <div v-for="(item, index) in boxlist" :key="index" style="text-align: center; margin-left: 15px; z-index: 2" @click="openBox(item)">
                  <div :class="'box-item box-bg' + item.status" />
                  {{ item.liveness }}
                </div>
              </div>
            </div>
          </van-col>
          <van-col :span="8">
            当日活跃度 <span style="color: #cca352">{{ usrdata.liveness }}</span>
          </van-col>
          <van-col :span="16" style="text-align: right">
            <div style="float: right">
              <div style="float: left">活跃度重置</div>
              <van-count-down style="width: 220px; color: #cca352 !important" :time="time" format="DD 天 HH 时 mm 分 ss 秒" />
            </div>
          </van-col>
        </van-row>
      </div>
      <div data-v-d5c8035c="" v-for="(item, index) in activitylistList1" :key="'stask_' + index" style="margin: 12px 0">
        <div style="float: left; width: calc(100% - 130px); padding: 5px 0">
          <div style="color: #fff; font-size: 16px; position: relative; height: 32px; line-height: 32px">
            <div style="float: left; max-width: calc(100% - 30px); overflow: hidden; white-space: nowrap">{{ item.title }}</div>
            <div style="">
              &nbsp;
              <van-icon name="question-o" @click="togglePopover(item.id)" />
            </div>
          </div>
          <van-progress :percentage="item.progress" pivot-color="#cca352" color="#cca352" stroke-width="8" style="margin-top: 10px" />
        </div>
        <div style="float: right; width: 125px; text-align: center">
          <div v-if="!item.is_completed" style="border: 2px solid #cca352; padding: 5px 10px; color: #fff; border-radius: 15px; color: #cca352" @click="toPage">去完成</div>
          <div v-else-if="item.is_completed && !item.is_claimed" style="border: 2px solid #cca352; padding: 5px 10px; color: #fff; border-radius: 15px; color: #cca352" @click="GetUsrTasklist(item)">领取</div>
          <div v-else style="border: 2px solid rgb(106, 106, 115); padding: 5px 10px; color: #fff; border-radius: 15px; color: rgb(106, 106, 115)">已领取</div>
          <van-row style="margin-top: 8px; color: #cca352">
            <van-col :span="12" style="font-size: 16px"><van-icon name="gold-coin-o" />&nbsp;{{ item.reward_bonus }}</van-col>
            <van-col :span="12" style="font-size: 16px; text-align: right"><van-icon name="like-o" />&nbsp;{{ item.reward_points }}</van-col>
          </van-row>
        </div>
        <div style="clear: both"></div>
        <van-divider />
      </div>
    </div>
    <van-popup v-model="show" style="padding: 30px 15px 15px; border-radius: 8px;background-color: #282828;" closeable position="bottom" round>
      <div style="margin-top: 30px;height: 38px;color: #fff;font-size: 18px;font-weight: 600;" v-if="selctItem && selctItem.title">{{ selctItem.title }}</div>
      <div style="border-top: 1px solid #eee;border-bottom: 1px solid #eee;height: 38px;line-height: 38px;color: #cca352;margin: 10px 0;">
        <p v-if="selctItem && selctItem.progress.toString().length > 0 && selctItem.status  == 0">进行中,已完成 {{ selctItem.progress }} %</p>
        <p v-else-if="selctItem && selctItem.status  == 1">可领取</p>
        <p v-else-if="selctItem&& selctItem.status  == 2">已领取</p>
      </div>
      <div style="color: #fff;" v-if="selctItem && selctItem.content" v-html="selctItem.content"></div>
    </van-popup>
  </div>
</template>
<script>
import { Notify } from 'vant';
export default {
  name: 'activeList',
  data () {
    return {
      time: 0,
      tabs: ['优惠活动', '日常任务'],
      selectIndex: 0,
      show: false,
      selctItem: null,

      usrdata: {},
      boxlist: [],

      activitylistList: [],
      activitytypelist: [],
      active: -1,

      activitylistList1: [],
      activitytypelist1: [],
      active1: null,
    };
  },
  created () {
    let that = this;
    that.activityTypelist();
    that.UsrTaskType();
    that.activitylist();
    // that.UsrTasklist();
    that.getUsrInfo();
    that.getUsrBox();

    const now = new Date();
    // 计算次日凌晨时间
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    // 计算时间差（毫秒）
    this.time = midnight - now;
  },
  methods: {
    changeIndex (val) {
      this.selectIndex = val;
      if (!this.active1) {
        const that = this;
        this.$nextTick(() => {
          that.active1 = this.activitylistList1[0].id;
        });
      }
    },
    toPage () {
      this.$router.push({ name: 'index' });
    },
    // 切换指定ID的popover状态
    togglePopover (id) {
      this.selctItem = null;
      this.activitylistList1.forEach(item => {
        if (item.id == id) {
          this.selctItem = item;
        }
      });
      console.log(this.selctItem)
      if (this.selctItem.content && this.selctItem.content.length > 0) {
        this.show = true;
      }
    },
    activityTypelist () {
      let that = this;
      let info = { type: '' };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitytype', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitytypelist = res.data;
          that.activitytypelist.unshift({ name: '全部优惠', id: -1 });
        }
        that.$parent.hideLoading();
      });
    },

    activitylist () {
      let that = this;
      let info = { type: '' };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },

    UsrTaskType () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.get('/api/taskType').then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitytypelist1 = res.data;
          that.active1 = res.data[0].id;
          this.UsrTasklist()
        }
        that.$parent.hideLoading();
      });
    },
    selectTask(){
      this.UsrTasklist()
    },
    UsrTasklist () {
      if(this.active1 == -1)return
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/userTask',{type_id:this.active1}).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList1 = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    GetUsrTasklist (item) {
      let that = this;
      console.log(item);
      that.$parent.showLoading();
      let info = { task_id: item.id };
      that.$apiFun.get('/api/claimTask', info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.$parent.showTost(0, res.message);
          that.UsrTasklist();
          that.getUsrInfo();
        }
        that.$parent.hideLoading();
      });
    },
    getUsrInfo () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.get('/api/userStats').then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.usrdata = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    getUsrBox () {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/userBox').then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.boxlist = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    openBox (item) {
      if (item.status != 1){
        Notify({  message: '打开后获得'+item.bonus_amount+'彩金，需要3倍流水可提现', color: '#ddd',background: '#3498db', duration: 3000});
        return
      }
      let that = this;
      that.$parent.showLoading();
      let info = { id: item.id };
      that.$apiFun
        .get('/api/doUserBox', info)
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.$parent.showTost(0, res.message);
            that.UsrTasklist();
            that.getUsrInfo();
            that.getUsrBox();
          }
          that.$parent.hideLoading();
        })
        .catch(err => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted () {
    let that = this;
  },
  updated () {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-38eb6c31.8e3fbc77.css';
.promotion .promo .promo-img[data-v-d5c8035c][data-v-076663fa] {
  height: auto;
}
.tab-div {
  height: 38px;
  line-height: 38px;
}
.tab-div .tab-box {
  margin: 0px auto;
  width: 70%;
  position: relative;
}
.tab-div .tab-box .tab-item {
  background: #34363f;
  color: #6a6a73;
  text-align: center;
  position: absolute;
  width: 58%;
  right: 0px;
  top: 0px;
  z-index: 1;
  border-radius: 24px;
  font-size: 16px;
}
.tab-div .tab-box .tab-item:first-child {
  left: 0px;
}
.tab-div .tab-box .tab-item-select {
  background: #cca352 !important;
  color: #fff;
  z-index: 2;
}

.box-item {
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-position: center;
}
.box-bg0 {
  background-image: url(../../../static/image/box/box.png);
  background-size: 56px auto;
}
.box-bg1 {
  background-image: url(../../../static/image/box/box1.png);
  background-size: 100% auto;
}
.box-bg2 {
  background-image: url(../../../static/image/box/box2.png);
  background-size: 100% auto;
}
</style>



// WEBPACK FOOTER //
// src/components/main/activeList.vue